<template>
  <div class='pt-5'>
    <section class='catg-area'>
      <div class='container'>
        <!-- <BarChart /> -->
        <JobSeekerStats/>
        <!-- <CategoryList /> -->
        <!-- <Chart /> -->
      </div><!-- container -->
    </section>
    <!-- <Summary /> -->
  </div>
</template>

<script>
import BarChart from '@/components/dashboard/chart/BarChart.vue';
import CategoryList from '@/components/dashboard/category/NewCategoryList.vue';
import Summary from '@/components/dashboard/Summary.vue';
import JobSeekerStats from '../components/dashboard/statTable/JobSeekerStats.vue';
import {mapGetters, mapActions} from 'vuex';

export default {
  name: 'Dashboard',
  components: {
    Summary,
    CategoryList,
    BarChart,
    JobSeekerStats,
},
  computed:{
    ...mapGetters({
      isReviewer:'isCreateReviewUser'
    })
  },
  methods:{
    ...mapActions({
      loadCurrentUser: 'loadCurrentUser'
    })
  },
  async mounted() {
    await this.loadCurrentUser();
    if(!this.isReviewer){
      this.$router.push({ path: '/applicant' });
    }
    this.changeBodyBackground();
  },
};
</script>

<style scoped>
.record-chart h4 {
  font-size: 16px;
  font-weight: 500;
  color: #036d6c;
  margin-bottom: 20px;
}

.record-display {
  background-color: #fbfcff;
  border-radius: 8px;
  -webkit-box-shadow: 0 0 12px 3px rgba(0, 60, 113, 0.08);
  box-shadow: 0 0 12px 3px rgba(0, 60, 113, 0.08);
  padding: 30px 35px 25px;
  margin-bottom: 40px;
}
</style>
